export default "/images/aa4063c256fd3301495c1af353be6d88.avif";